import axios from "axios";
import { API_URL } from "const/constants";

export const fetchClientFormPage = async ({
  page = 0,
  pageSize = 20,
  search = "",
  type = "",
  convertedFilter = "",
} = {}) => {
  const params = {
    page,
    size: pageSize,
    ...(search ? { search } : {}),
    ...(type ? { type } : {}),
    ...(convertedFilter ? { convertedFilter } : {}),
  };
  const res = await axios.get(`${API_URL}/client-form/page`, { params });
  return res?.data?.data ?? { content: [], totalItems: 0, totalPages: 0 };
};

/**
 * One-click conversion from the list. Deliberately payload-free — the full PUT replaces every
 * field, and the list row does not carry them all.
 */
export const convertClientForm = async (formId) => {
  const res = await axios.post(`${API_URL}/client-form/${formId}/convert`);
  return res?.data?.data ?? null;
};
